import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import { makeModal } from './makeModal';

// eslint-disable-next-line @wix/da/create-action-payload-creator
export const pushModal = createAction(`${actionPrefix}.PUSH_MODAL`, makeModal);
// eslint-disable-next-line @wix/da/create-action-payload-creator
export const replaceModal = createAction(`${actionPrefix}.REPLACE_MODAL`, makeModal);
export const popModal = createAction(`${actionPrefix}.POP_MODAL`, () => ({}));
export const popAllModals = createAction(`${actionPrefix}.POP_ALL_MODALS`, () => ({}));
export const removeModalsOfType = createAction(
  `${actionPrefix}.REMOVE_MODAL_TYPE`,
  (type: string) => type
);
export const removeModal = createAction(`${actionPrefix}.REMOVE_MODAL`, (id: number) => id);
